export default class CubemapAsset {
  constructor(images) {
    this.images = images;
    this.userData = null;
  }
}
